import { render, staticRenderFns } from "./fresh-water-form.vue?vue&type=template&id=6b2982ee&scoped=true&"
import script from "./fresh-water-form.vue?vue&type=script&lang=js&"
export * from "./fresh-water-form.vue?vue&type=script&lang=js&"
import style0 from "./fresh-water-form.vue?vue&type=style&index=0&id=6b2982ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2982ee",
  null
  
)

export default component.exports